module.exports = __webpack_public_path__ + "assets/9ddb5909176ce0de7b792424fc030039.jpg";